import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Media from 'react-media';
import styled from 'styled-components';
import GlobalTheme from '../../styled/GlobalTheme';
import mediaQueries from '../../utils/mediaQueries';
import { Button } from '../buttons';
import roles from '../../utils/constants/roles';
import routes from '../../utils/constants/routes';
import { AnalyticsContext } from '../../contexts/AnalyticsContext';
import {
  CheckGreen,
  FailIcon,
} from '../../assets/icons/iconRepository';

const Row = styled.div`
    padding: 0;
    margin:auto;
    background-color: ${GlobalTheme.colors.white};
    display: grid;
    width:100%;
    grid-template-columns: 4fr 1.5fr 0fr 0fr;
    justify-items: center;
    align-items: center;
    border-bottom: 1px solid ${GlobalTheme.colors.grayE9};
    height:35px;
    ${GlobalTheme.breakpoints.up('md')}{
      grid-template-columns: 4fr 1.5fr 0fr 0fr;
      column-gap: 10px;
      padding: 0 20px;
    }
    ${GlobalTheme.breakpoints.up('lg')}{
      grid-template-columns: 4fr 1.5fr 0fr 0fr;
      column-gap: 10px;
      padding: 0 10px;
    }
    ${GlobalTheme.breakpoints.down('sm')}{
      height:39px;
      padding: 0 10px;
    }
`;
const TitleRow = styled.div`

`;

const ButtonRow = styled(TitleRow)`
  border: none;
`;

const TableRowTittle = styled.div`
  font-size: 24px;
  font-weight: 700;
  background-color: #00B4CC;
  color: white;
  text-align: center;
  height: 60px;
`;

const CommingSoon = styled.div`
  font-size: 13px;
  font-weight: 700;
  width: 100%;
  text-align: center;
  color: ${GlobalTheme.colors.orange};
  ${GlobalTheme.breakpoints.up('md')}{
    font-size: 20px;
  }
`;

const Cell = styled.div`
  font-size: 10px;
  width: 100%;
  text-align: center;
  ${GlobalTheme.breakpoints.up('md')}{
    font-size: 12px;
  }
  ${GlobalTheme.breakpoints.up('lg')}{
    font-size: 16px;
  }
`;

const FeaturedContainerCell = styled.div`
  background-color: ${GlobalTheme.colors.screenBackground};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const RowTitle = styled(Cell)`
text-align: left;
`;

const Check = styled.div`
  display: inline-block;
  width: 24px;
  height: 18px;
  background-image: url(${CheckGreen});
  background-repeat: no-repeat;
  background-size: cover;
`;
const Fail = styled.div`
  display: inline-block;
  width: 17px;
  height: 17px;
  background-image: url(${FailIcon});
  background-repeat: no-repeat;
  background-size: cover;
`;

const CustomButton = styled(Button)`
  && {
    background: ${({ color }) => color};
    color: ${({ theme }) => theme.colors.white};
    &:disabled {
      background: ${({ theme }) => theme.colors.grayE9};
    }
    &:hover {
      background: ${({ color }) => color};
    }
  }
`;

const RowItem = ({
  data,
}) => {
  let {
    title, proValue, bizValue, liteValue, isComingSoon,
  } = data;
  if (proValue) {
    proValue = (<Check />);
  }
  if (!proValue) {
    proValue = (<Fail />);
  }
  if (bizValue) {
    bizValue = (<Check />);
  }
  if (!bizValue) {
    bizValue = (<Fail />);
  }
  if (liteValue) {
    liteValue = (<Check />);
  }
  if (!liteValue) {
    liteValue = (<Fail />);
  }
  return (
    <Row>
      <RowTitle>{title}</RowTitle>
      <FeaturedContainerCell>
        <Cell>
          {isComingSoon ? (
            <FormattedMessage
              id="k.comingSoon"
              defaultMessage="Coming Soon"
            />
          ) : proValue}
        </Cell>
      </FeaturedContainerCell>
    </Row>
  );
};

const CompareTable = ({ show, showButtons }) => {
  const intl = useIntl();
  const tableValues = [{
    title: intl.formatMessage({
      id: 'comparePlans.ceil1',
      defaultMessage: 'Connect Facebook, Instagram, Twitter & LinkedIn',
    }),
    proValue: intl.formatMessage({
      id: 'comparePlans.oneAccountPN',
      defaultMessage: '1 Account per network',
    }),
  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil2',
      defaultMessage: 'Users per account',
    }),
    proValue: 1,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil3',
      defaultMessage: 'Schedule/publish your content daily, weekly, or monthly',
    }),
    proValue: intl.formatMessage({
      id: 'comparePlans.unlimited',
      defaultMessage: 'Unlimited',
    }),

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil4',
      defaultMessage: 'Ready to use/edit social creative templates',
    }),
    proValue: intl.formatMessage({
      id: 'comparePlans.unlimited',
      defaultMessage: 'Unlimited',
    }),

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil5',
      defaultMessage: 'Watch your competitor’s social media activity',
    }),
    proValue: intl.formatMessage({
      id: 'comparePlans.unlimited',
      defaultMessage: 'Unlimited',
    }),

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil6',
      defaultMessage: 'Your Business social media posts calendar management',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil7',
      defaultMessage: 'Recommendations for your best date and time to publish',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil8',
      defaultMessage: 'Reply to your clients comments/direct messages from one place',
    }),
    proValue: true,
  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil9',
      defaultMessage: 'Create awesome content for your business with our graphic editor',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil10',
      defaultMessage: 'Access the educational content in our Social Piper Academy',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil11',
      defaultMessage: 'Customer Success Webinars',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil12',
      defaultMessage: 'Manage your business’ Social Media Ads',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil13',
      defaultMessage: 'Recomendations for boosting to maximize your campaigns',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil14',
      defaultMessage: 'Social Ads reports in real time',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil15',
      defaultMessage: 'Manage Social Piper from the mobile app',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil16',
      defaultMessage: 'Instagram direct Scheduling',
    }),
    proValue: true,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil17',
      defaultMessage: 'Approval workflow to get everyone on board before publishing/advertising',
    }),
    proValue: false,

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil18',
      defaultMessage: 'Technical Support 24/7',
    }),
    proValue: intl.formatMessage({
      id: 'comparePlans.helpCenter',
      defaultMessage: 'Help Center, Chat and Email',
    }),

  }, {
    title: intl.formatMessage({
      id: 'comparePlans.ceil20',
      defaultMessage: 'Payment Methods',
    }),
    proValue: intl.formatMessage({
      id: 'comparePlans.payments',
      defaultMessage: 'Visa, Mastercard, AMEX, Discovery',
    }),
  }];
  const history = useHistory();
  const { dataLayerPush } = useContext(AnalyticsContext);
  const onClickHandler = (roleUse) => {
    dataLayerPush({
      pagePath: `/homepage/compareTable/${roleUse}`,
      pathTitle: 'Landing Pricing',
      dataAction: 'Choose piper plan',
      event: 'action',
    });
    history.push({
      pathname: routes.CREATE_ACCOUNT,
      state: {
        plan: roleUse,
      },
    });
  };

  return (
    (show && (
      <Media queries={mediaQueries}>
        {(matches) => (
          <>
            <TitleRow>
              <TableRowTittle>
                {
                  intl.formatMessage({
                    id: 'k.title.modal', defaultMessage: 'Pro Plan details',
                  })
                }
              </TableRowTittle>
            </TitleRow>

            {tableValues.map((value) => (
              <RowItem
                data={value}
              />
            ))}
            {showButtons && !matches.smDown && (
              <ButtonRow>
                <Cell />
                <Cell>
                  <CustomButton
                    color={GlobalTheme.colors.lightBlue}
                    onClick={() => onClickHandler(roles.PRO)}
                  >{intl.formatMessage({
                    id: 'k.signup.btn',
                    defaultMessage: 'Sign Up!',
                  })}
                  </CustomButton>
                </Cell>
                <CommingSoon>{intl.formatMessage({
                  id: 'k.comingSoon', defaultMessage: 'Coming Soon',
                })}
                </CommingSoon>
                <Cell>
                  <CustomButton
                    color={GlobalTheme.colors.lightPurple}
                    onClick={() => onClickHandler(roles.BASIC)}
                  >{intl.formatMessage({
                    id: 'k.signup.btn',
                    defaultMessage: 'Sign Up!',
                  })}
                  </CustomButton>
                </Cell>
              </ButtonRow>
            )}
          </>
        )}
      </Media>
    )));
};

export default CompareTable;
